// extracted by mini-css-extract-plugin
export var addressFields = "_jd-0";
export var animationContainer = "_jd-1";
export var footer = "_jd-2";
export var lineItems = "_jd-3";
export var modalContent = "_jd-4";
export var orderName = "_jd-5";
export var strong = "_jd-6";
export var warning = "_jd-7";